import React from 'react';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainRoutes } from 'main-routes';
import { websiteTitle } from 'config';

// Function to get translation key for page title
const getTranslationKeyForPageTitle = ( pathname: string ): string => {
  // Remove /u/:accountIndex prefix from path
  const normalizedPath = pathname.replace( /^\/u\/\d+/, '' );
  const matchedRoute = mainRoutes.find( ( route ) => {
    return matchPath( normalizedPath, { path: route.path, exact: route.exact } );
  } );

  // Mapping of static routes not included in mainRoutes
  const staticPathToTranslationKey: { [key: string]: string } = {
    '/login': 'auth:login.title',
    '/login/readme': 'auth:login.title',
    '/login/saml': 'auth:login.title',
    '/sso/callback': 'auth:login.title',
    '/account/resetpassword': 'auth:resetPassword.title',
    '/registration': 'registration:pageTitle',
    '/organization/registration': 'registration:organizations.pageTitle',
    '/expired-token': 'registration:expiredMessageTitle',
    '/success-registration': 'registration:successMessageTitle',
    '/forms': 'forms:pageTitle',
    '/management/product-settings/product': 'product:createProduct',
  };

  // Check static routes
  if ( staticPathToTranslationKey[normalizedPath] ) {
    return staticPathToTranslationKey[normalizedPath];
  }

  // Check dynamic routes (e.g., /login/:tenantName, /download/:s3key)
  const dynamicMatch = matchPath( pathname, { path: '/login/:tenantName' } );
  if ( dynamicMatch ) {
    return 'auth:login.title';
  }

  return matchedRoute?.title || 'base:messages.error';
};

// Component for managing page title
const PageTitle: React.FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation( [
    'base',
    'registration',
    'tariff-comparison',
    'forms',
    'auth',
    'helpCenter',
    'customer',
    'payment-processing',
    'vwb',
    'fzv',
    'process-editor',
    'product',
    'lead',
    'policy',
  ] );

  React.useEffect( () => {
    const translationKey = getTranslationKeyForPageTitle( pathname );
    document.title = t( translationKey ) + ` | ${websiteTitle}`;
  }, [ pathname, t ] );

  return null; // Component doesn't render anything
};

export default PageTitle;
